var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.524414,
    y: 0.393555,
    width: 67.6721,
    height: 64.8525,
    rx: 32.4262,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.36 13.6006C32.8447 13.6006 31.3914 14.2025 30.3199 15.274C29.2484 16.3455 28.6465 17.7988 28.6465 19.3141C28.6465 20.8295 29.2484 22.2827 30.3199 23.3542C31.3914 24.4257 32.8447 25.0277 34.36 25.0277C35.8754 25.0277 37.3286 24.4257 38.4001 23.3542C39.4716 22.2827 40.0736 20.8295 40.0736 19.3141C40.0736 17.7988 39.4716 16.3455 38.4001 15.274C37.3286 14.2025 35.8754 13.6006 34.36 13.6006V13.6006Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3609 14.1209C37.2249 14.1209 39.555 16.4509 39.555 19.315C39.555 22.179 37.2249 24.5091 34.3609 24.5091C31.4968 24.5091 29.1668 22.179 29.1668 19.315C29.1668 16.4509 31.4968 14.1209 34.3609 14.1209ZM34.3609 13.082C30.9182 13.082 28.1279 15.8723 28.1279 19.315C28.1279 22.7577 30.9182 25.548 34.3609 25.548C37.8036 25.548 40.5938 22.7577 40.5938 19.315C40.5938 15.8723 37.8036 13.082 34.3609 13.082Z",
    fill: "#374151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2432 18.2764H37.4761V20.354H31.2432V18.2764Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2588 33.6719H22.4141V52.0373H18.2588V33.6719Z",
    fill: "#F3F4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8955 34.1921V51.5187H18.7791V34.1921H21.8955ZM22.9344 33.1533H17.7402V52.5576H22.9344V33.1533Z",
    fill: "#374151"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 43.7275H46.3071V46.844H22.4141V43.7275Z",
    fill: "#F3F4F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7885 44.2468V46.3245H22.9343V44.2468H45.7885ZM46.8273 43.208H21.8955V47.3633H46.8273V43.208Z",
    fill: "#374151"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3066 33.6719H50.4619V52.0373H46.3066V33.6719Z",
    fill: "#F3F4F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9434 34.1921V51.5187H46.8269V34.1921H49.9434ZM50.9822 33.1533H45.7881V52.5576H50.9822V33.1533Z",
    fill: "#374151"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1416 25.0283H53.5782V34.3778H15.1416V25.0283Z",
    fill: "#374151"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0596 25.5486V33.8592H15.6619V25.5486H53.0596ZM54.0985 24.5098H14.623V34.898H54.0985V24.5098Z",
    fill: "#374151"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2927 25.5479H21.4151L15.6621 33.8585H18.5386L24.2927 25.5479ZM31.4845 25.5479H28.608L22.8539 33.8585H25.7304L31.4845 25.5479ZM38.6763 25.5479H35.7998L30.0457 33.8585H32.9222L38.6763 25.5479ZM45.8681 25.5479H42.9916L37.2375 33.8585H40.114L45.8681 25.5479ZM53.0599 25.5479H50.1834L44.4293 33.8585H47.3068L53.0599 25.5479ZM51.6211 33.8585H53.0599V31.7808L51.6211 33.8585ZM17.1009 25.5479H15.6621V27.6255L17.1009 25.5479Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDml);
export default __webpack_public_path__ + "static/media/dml.b9c3c310de942fb34cdecaa817da247a.svg";
export { ForwardRef as ReactComponent };